import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CardModule } from '@app/content/shared/card/card.module';
import { PendingActionsComponent } from './pending-actions.component';
import { PendingActionsContainer } from './pending-actions.container';

@NgModule({
    imports: [
        CommonModule,
        CardModule,
    ],
    exports: [
        PendingActionsContainer,
    ],
    declarations: [
        PendingActionsComponent,
        PendingActionsContainer,
    ],
})
export class PendingActionsModule { }
